import "../../../src/Components/Inmobiliarias/styles.less";

import { Card, Col, Collapse, Empty, Input, List, Row, Skeleton } from "antd";
import {
	CardContent,
	CardTopCover,
	ItemGroupInmob,
} from "../../../src/Components/Inmobiliarias/inmoComponents";
import React, { useContext } from "react";

import { ColProps } from "antd/lib/grid/col";
import { DownOutlined } from "@ant-design/icons";
import { PageLayout } from "../../../src/Components/Layout/web";
import { PropertyCardSkeleton } from "../../../shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";
import { Title } from "../../../shared-components/Components/Property/Title/web";
import { useRealEstateAgents } from "../../../src/Components/Inmobiliarias/hook";
import { useTheme } from "../../../shared-components/Styles/ThemeHook";
import { withApollo } from "../../../lib/apollo3";
import { withAuth } from "../../../lib/auth";
import { withContext } from "../../../lib/context";
import { withGlobalComponents } from "../../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../../shared-components/i18n";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

const { Panel } = Collapse;

// Page Inmobiliarias
const Inmobiliarias = () => {
	const { theme } = useTheme();
	const keysCollapse = ["# - A - F", "G - K", "L - O", "P - T", "U - Z"];
	const {
		loading,
		error,
		data: { inmoFull, notInmoFull },
		handleSearch,
		compare,
	} = useRealEstateAgents();
	const { country_name } = useContext(ConfigStateContext);
	

	if (error) return null;

	return (
		<PageLayout classContainer="inmob-container">
			<Row
				gutter={[
					0,
					{
						xs: theme.spacing.xxlSpacing * 2,
						sm: theme.spacing.xxlSpacing * 2,
						md: theme.spacing.smSpacing * 6,
					},
				]}>
				{/* Inmob-Top-Search */}
				<Col span={24}>
					<div className="inmob-top-search">
						<div className="container">
							{/* Title */}
							{country_name ? (
								<Title
									title={`Inmobiliarias en ${country_name}`}
									hideInformation
									level={1}
								/>
							) : (
								<Skeleton
									active
									paragraph={false}
									title={{style:{ width: 250, height: 30, borderRadius: 5}}}
								/>
							)}
							{/* Search */}
							<Input
								className="search-bar"
								placeholder={"Buscá por inmobiliaria o palabra clave"}
								onChange={handleSearch}
							/>
						</div>
					</div>
				</Col>
				{loading || !inmoFull || !notInmoFull ? (
					// Skeleton
					<Col span={24}>
						<div className="container">
							<List
								itemLayout={"horizontal"}
								dataSource={[...Array(6)].map((o, i) => i)}
								grid={{
									gutter: theme.spacing.lgSpacing,
									column: 3,
									xs: 1,
									sm: 2,
									lg: 2,
									xxl: 3,
								}}
								renderItem={o => (
									<List.Item>
										<PropertyCardSkeleton />
									</List.Item>
								)}
							/>
						</div>
					</Col>
				) : (
					<>
						{/* Inmob-Cards */}
						{inmoFull.length > 0 && (
							<Col span={24} style={{ paddingTop: 0 }}>
								<div className={"inmob-cards"}>
									<div className="container">
										<Row
											align={"top"}
											gutter={[
												theme.spacing.lgSpacing,
												theme.spacing.lgSpacing,
											]}>
											{inmoFull.map(inmob => {
												let grid: ColProps = {
													xs: 24,
													sm: 12,
													md: 12,
													lg: 8,
													xl: 8,
													xxl: 8,
												};
												return (
													inmob.img_cover &&
													inmob.name &&
													inmob.color &&
													inmob.logo_v2 &&
													inmob.description && (
														<Col
															className="inmob-item"
															key={"inmob_" + inmob.id}
															{...grid}>
															<Card
																cover={
																	<CardTopCover
																		item={inmob}
																	/>
																}>
																<CardContent item={inmob} />
															</Card>
														</Col>
													)
												);
											})}
										</Row>
									</div>
								</div>
							</Col>
						)}
						{/* Inmob-Groups */}
						{notInmoFull && (
							<Col span={24}>
								<div className="inmob-groups ">
									<div className="container">
										<Collapse
											ghost
											bordered={false}
											defaultActiveKey={keysCollapse}
											expandIconPosition="right"
											expandIcon={({ isActive }) => (
												<DownOutlined rotate={isActive ? 180 : 0} />
											)}>
											{Object.keys(notInmoFull)
												.sort()
												.map(group => (
													<Panel
														header={
															<Title
																title={group}
																hideInformation
																level={4}
															/>
														}
														key={group}>
														<List
															grid={{
																gutter: 16,
																xs: 3,
																sm: 4,
																md: 5,
																lg: 6,
																xl: 7,
																xxl: 7,
															}}
															dataSource={notInmoFull[group].sort(
																compare
															)}
															renderItem={item => (
																<List.Item className="inmob-item">
																	<ItemGroupInmob
																		item={item}
																	/>
																</List.Item>
															)}
														/>
													</Panel>
												))}
										</Collapse>
									</div>
								</div>
							</Col>
						)}
						{/* Inmob-Empty */}
						{Object.entries(notInmoFull).length === 0 && inmoFull.length === 0 && (
							<Empty description={"Sin Datos"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
					</>
				)}
			</Row>
		</PageLayout>
	);
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(Inmobiliarias))), {
		withDummyContext: false,
		withFiltersContext: false,
		withConfigContext: true,
		withThemeContext: true,
	})
);
